import React from 'react'
import './StepThree.css'
import { NavLink } from 'react-router-dom';
import logo from '../../../assets/img/b-logo.svg'
import paymentimg from '../../../assets/img/payment.svg'
import { Row, Col, Button, Input, Checkbox, Select } from 'antd';

const StepThree = ({ stepThreeDone, successDone }) => {

    const { Option } = Select;

    return(
        <Col className={`gutter-row signup_step_three ${stepThreeDone === true ? 'show_three' : 'hide_three'}`} xs = {{ span: 24 }} sm = {{ span: 24 }} md = {{ span: 24 }} lg = {{ span: 24 }} xl ={{ span: 24 }}>

            <div className="playarone">
                <NavLink exact to="/" >
                    <img src={logo} alt="" />
                </NavLink>
                
                <NavLink exact to="/sign-in" >
                    <p>Already have an account? <span>Sign In</span></p>
                </NavLink>
            </div>

            <Row gutter={[16, 24]} className="signup_step3_container">

                <Col xs = {{ span: 24 }} sm = {{ span: 22 }} md = {{ span: 18 }} lg = {{ span: 14 }} xl ={{ span: 12 }}>

                    <div className="signup_stepthree_holder">
                        <img src={paymentimg} alt="" style={{ width: '60px' }}/>

                        <p className="step_3_text">STEP 2 of 2</p>

                        <h3>Finish account setup</h3>

                        <p className="signup_mem_text">Your membership start as soon as you set up payment.</p>

                        <div className="signup_plan">
                            <Row gutter={[16, 24]}>
                                <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                    <Input placeholder="First Name" />
                                </Col>
                                <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                    <Input placeholder="Last Name" />
                                </Col>
                                <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                    <Input placeholder="Create Username" />
                                </Col>
                                <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                    <Input.Group size="large">
                                        <Row gutter={8}>
                                            <Col span={6}>
                                            <Input placeholder="Ext." />
                                            </Col>
                                            <Col span={18}>
                                            <Input placeholder="Mobile (optional)" />
                                            </Col>
                                        </Row>
                                    </Input.Group>
                                </Col>
                                <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                    <Input placeholder="PSN ID" />
                                </Col>
                                <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                    <Input placeholder="Xbox Gamertag" />
                                </Col>
                                <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                    <Input placeholder="Discord Username" />
                                </Col>
                                <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                    <Select defaultValue="Option1-1">
                                        <Option value="Option1-1">Time Zone</Option>
                                        <Option value="Option1-2">Time Zone 2</Option>
                                    </Select>
                                </Col>
                                <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                    <Select defaultValue="Option1-1">
                                        <Option value="Option1-1">Favourite Streaming Channel</Option>
                                        <Option value="Option1-2">Favourite Streaming Channel-2</Option>
                                    </Select>
                                </Col>
                                <Col xs = {{ span: 24 }} sm = {{ span: 12 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                                    <Input placeholder="Selected Channel URL" />
                                </Col>

                                <Checkbox>Do not email me PlayarOne special offers.</Checkbox>
                            </Row>
                        </div>

                        <Button type="primary" onClick={successDone}>finish signup</Button>

                        <div className="signup_commitment">
                            <p>No commitments.<br/>
                            Cancel your subscription at anytime.</p>
                        </div>

                    </div>

                </Col>

            </Row>
            
        </Col>
    );
}

export default StepThree;